import React from 'react'
import MainLayout from '../Layouts/Mainlayout'
import ClientList from './ClientList'

function Clients(): JSX.Element {
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <ClientList />
      </MainLayout>
    </div>
  )
}

export default Clients